<template>
  <div class="message-body-scan">
    <div class="flex items-center">
      <div class="button" @click="$emit('begin-scan')">{{ $t('chat.body_scan') }}</div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.message-body-scan {
  font-size: 16px;
  padding: 16px;

  .button {
    border: 1px solid #fff;
    border-radius: 38px;
    padding: 4px 12px;
  }
}
</style>
